import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Sorry", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Requested content not found.", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_f7_navbar = _resolveComponent("f7-navbar");
  const _component_f7_block = _resolveComponent("f7-block");
  const _component_f7_page = _resolveComponent("f7-page");
  return _openBlock(), _createBlock(_component_f7_page, null, {
    default: _withCtx(() => [_createVNode(_component_f7_navbar, {
      title: "Not found",
      "back-link": "Back"
    }), _createVNode(_component_f7_block, {
      strong: ""
    }, {
      default: _withCtx(() => [_hoisted_1, _hoisted_2]),
      _: 1
    })]),
    _: 1
  });
}